
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"line-height":"normal","text-indent":"0","text-align":"start","text-decoration-line":"none","text-decoration-style":"solid","text-decoration-color":"#000","text-transform":"none","block-progression":"tb","isolation":"auto","mix-blend-mode":"normal"},attrs:{"d":"M3 5a1 1 0 100 2h18a1 1 0 100-2H3zm0 6a1 1 0 100 2h18a1 1 0 100-2H3zm0 6a1 1 0 100 2h18a1 1 0 100-2H3z","font-weight":"400","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    